(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-header-new"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.smarte-header');
this.headerIsAlwaysSticky =
this.getAttribute('data-sticky-type') === 'always' ||
this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
}

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
if (window.matchMedia('(max-width: 768px)').matches) {
if (window.scrollY > 10) {
this.header.classList.add('scrolling');
} else {
this.header.classList.remove('scrolling');
}
} else {
if (window.scrollY > 100) {
this.header.classList.add('scrolling');
} else {
this.header.classList.remove('scrolling');
}
}

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach((disclosure) => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-header-usp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.mobile-slider', {
    loop: true,
    initialSlide: 3,
    breakpoints: {
      760: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1,
      },
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-recently-viewed-init"] && !Shopify.designMode) return;
  try {
    
    (async function () {
      if (!window.ks_recently_viewed.product) return
  
      let recentlyViewed = JSON.parse(localStorage.getItem('smarte-recently-viewed')) || []
      const product = window.ks_recently_viewed.product
      const limit = window.ks_recently_viewed.limit
  
      const isViewed = recentlyViewed.some((elem) => elem.url === product.url)
  
      if (isViewed) {
        recentlyViewed = recentlyViewed.filter((elem) => elem.url !== product.url)
      }
  
      recentlyViewed.push({
        url: product.url,
        id: product.id,
        handle: product.handle,
        title: product.title,
        img_src: product.img_src,
        img_alt: product.img_alt,
        compare_at_price: product.compare_at_price,
        price: product.price,
        price_varies: product.price_varies,
        added_at: Date.now()
      })
  
      function keepLastXItemsInArray(arr, x) {
        if (x >= 0 && x <= arr.length) {
          return arr.slice(-x)
        } else {
          return arr
        }
      }
  
      recentlyViewed = keepLastXItemsInArray(recentlyViewed, Number(limit))
      localStorage.setItem('smarte-recently-viewed', JSON.stringify(recentlyViewed))
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-recently-viewed"] && !Shopify.designMode) return;
  try {
    
class SmarteRecentlyViewed extends HTMLElement {
    constructor () {
        super()

        this.recentlyViewed = JSON.parse(localStorage.getItem('smarte-recently-viewed')) || []

        if (this.recentlyViewed.length) {
            this.setProductList()
            this.querySelector('#product-grid').removeAttribute('hidden')        
        } else {
            this.parentNode.style.display = 'none';
        }
    }

    setProductList () {
        let productList = ''

        this.recentlyViewed.reverse().forEach((product, index) => {
            productList += `
            <li class="smarte-rv">
                <div class="smarte-card-overrides card-wrapper product-card-wrapper underline-links-hover">
                    <div class="card"> 
                      <div class="card__inner">
                        <a style="text-decoration:none;" href="${product.url}">
                            <img
                            src="${product.img_src}" 
                            class="img-fluid ${this.dataset.imgBorder || ''}"
                            alt="${product.img_alt}" 
                            loading="lazy" height="235" width="248">

                        </a>
                    </div>
                        <div class="card__content">
                            <div class="card__information">
                                <a style="text-decoration:none;" href="${product.url}"><h3 class="card__heading h5">${product.title}</h3></a>
                                <div class="price">
                                    <div style="width:100%;" class="price__container">
                                        <div class="price__regular" ${product.compare_at_price > product.price ? '' : 'hidden'}>
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span class="price-item price-item--regular">${this.formatMoney(product.price)}</span>
                                        </div>
                                        <div class="price__sale" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span><s class="price-item price-item--regular">${this.formatMoney(product.compare_at_price)}</s></span>
                                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                            <span class="price-item price-item--sale price-item--last">${this.formatMoney(product.price)}</span>
                                        </div>
                                           <div class="smarte-view-product-button" style="margin-top:20px;">
                                                  <button
                                                      type="submit"
                                                      class="button smarte-main-buton"
                                                       onclick="window.location.href='${product.url}';"
                                                  >
                                                      <span class="content"> Add to Cart </span>
                                                      <span class="icon"><i class="fa-solid fa-circle-arrow-right"></i></span>
                                                  </button>
                                          </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            `
        });

        this.querySelector('#product-grid').innerHTML = productList;
    }

    formatMoney (cents, moneyFormat = this.dataset.moneyFormat) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '')
        }

        let value = ''
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

        function defaultOption (opt, def) {
            return (typeof opt === 'undefined' ? def : opt)
        }

        function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2)
            thousands = defaultOption(thousands, ',')
            decimal = defaultOption(decimal, '.')

            if (isNaN(number) || number == null) {
                return 0
            }

            number = (number / 100.0).toFixed(precision)

            const parts = number.split('.')
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
            const cents = parts[1] ? (decimal + parts[1]) : ''

            return dollars + cents
        }

        switch (moneyFormat.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2)
                break
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0)
                break
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',')
                break
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',')
                break
        }

        return moneyFormat.replace(placeholderRegex, value)
    }
}

customElements.define('smarte-recently-viewed', SmarteRecentlyViewed)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-reviews"] && !Shopify.designMode) return;
  try {
    
if (window.innerWidth <= 900) {
const iconTextElements = document.querySelectorAll('.smarte-icon-and-text-inner');
let currentIndex = 0;

function showNextElement() {
iconTextElements.forEach(element => element.classList.remove('show'));
iconTextElements[currentIndex].classList.add('show');
currentIndex = (currentIndex + 1) % iconTextElements.length;
}

setInterval(showNextElement, 2000);
showNextElement();
}

  } catch(e) { console.error(e); }
})();
})();
